/**
 * removeEmptyKeys iterates through passed object, removes any keys that are empty, and returns the same object with
 * empty keys removed.
 * @param objectWithEmptyKeys the object containing empty keys
 * @returns the object with empty keys removed
 */
export const removeEmptyKeys = (object) => {
    for (const [key, value] of Object.entries(object)) {
        (value !== null &&
            typeof value === "object" &&
            removeEmptyKeys(value)) ||
            ((!value || (typeof value === "string" && value?.trim() === "")) && delete object[key]);
    }
    return object;
};
